import LoaderInterstitial from './LoaderInterstitial';
export * from './LoaderInterstitial';
export default LoaderInterstitial;
